import axios from 'axios';
import { API_URL } from '../utils/constants';

export const courseAPI = {
  // Get Carousel/Banner Data
  getCarousel: async () => {
    const response = await axios.get(`${API_URL}/carousel`);
    return response.data;
  },

  // Get Trending Courses
  getTrending: async () => {
    const response = await axios.get(`${API_URL}/trending`);
    return response.data;
  },

  // Get All Courses
  getAllCourses: async () => {
    const response = await axios.get(`${API_URL}/getAllCourse`);
    return response.data;
  },

  // Get Course Details (Subjects) - matching mobile app
  getCourseDetails: async (courseId, userId = '0') => {
    const validUserId = userId || '0';
    const response = await axios.get(`${API_URL}/courses/${courseId}/${validUserId}`);
    return response.data;
  },

  // Get Carousel/Banner Course Details - matching mobile app
  getCarouselCourse: async (courseId, userId = '0') => {
    const validUserId = userId || '0';
    const response = await axios.get(`${API_URL}/carouselCourses/${courseId}/${validUserId}`);
    return response.data;
  },

  // Get Demo/Free Videos
  getDemoSubjects: async () => {
    const response = await axios.get(`${API_URL}/demosubject`);
    return response.data;
  },

  // Get Subjects by ID
  getSubjectById: async (subjectId) => {
    const response = await axios.get(`${API_URL}/getSubjectById/${subjectId}`);
    return response.data;
  },

  // Get Subject Videos
  getSubjectVideos: async (courseId, subjectId) => {
    const response = await axios.get(`${API_URL}/getSubjectVideo/${courseId}/${subjectId}`);
    return response.data;
  },

  // Get My Purchased Courses - matching mobile app endpoint
  getMyPurchased: async (userId) => {
    const response = await axios.get(`${API_URL}/getMypurchase/${userId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 10000,
    });
    return response.data;
  },

  // Get Homepage Data (Legacy - keeping for compatibility)
  getHomeData: async (userId = '') => {
    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('device_id', '');

    const response = await axios.post(`${API_URL}/getHomeData`, formData);
    return response.data;
  },

  // Get Homepage Data (Alternative)
  getHomepage: async () => {
    const response = await axios.get(`${API_URL}/homepage`);
    return response.data;
  },

  // Get Course by Category
  getCourseByCategory: async (categoryId) => {
    const response = await axios.get(`${API_URL}/getSubjectByCategory/${categoryId}`);
    return response.data;
  },
};

